import { Observer } from '@nextforce/api'
import { Text, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import { View } from 'react-native'
import SearchBar from 'shared/components/search_bar'

export function MemberSearchBar({
  filteredUsers,
  setSearchEnabled,
  setSearchTerm,
  searchTerm,
}: {
  filteredUsers: Observer[] | undefined
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  setSearchEnabled: React.Dispatch<React.SetStateAction<boolean>>
  searchTerm: string
}) {
  const styles = useStyles()
  return (
    <View style={styles.card}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Text style={styles.listHeaderText}>{t('filteredMembers')}</Text>
        <View style={styles.storeCountContainer}>
          <Text style={styles.storeCountText}>
            {filteredUsers?.length ?? 0}
          </Text>
        </View>
      </View>
      <View style={styles.searchBar}>
        <SearchBar
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          onPressClear={() => {
            setSearchEnabled(false)
            setSearchTerm('')
          }}
        />
      </View>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  listHeaderText: { fontSize: 16, marginRight: 5 },
  card: {
    backgroundColor: theme.colors.white,
    marginBottom: 2,
    padding: 15,
  },
  text: {
    fontSize: 14,
    marginRight: 5,
  },
  storeCountContainer: {
    marginVertical: 5,
    padding: 2,
    backgroundColor: theme.colors.peach,
    borderRadius: 50,
  },
  storeCountText: {
    fontSize: 14,
    paddingHorizontal: 10,
    color: 'black',
  },
  searchBar: {
    flexDirection: 'row',
    backgroundColor: theme.colors.white,
  },
}))
